import React from "react";
import Tooltip from "react-tooltip";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  InformationCircleIcon,
  NewspaperIcon,
  RectangleStackIcon,
} from "@heroicons/react/24/solid";

import useAgreementsCount from "../../CarrierAgreementMgmt/Agreements/hooks/useAgreementsCount";
import DashboardCard2 from "../../../components/DashboardCard2";
import { PERMISSIONS } from "../../PermissionsConstants";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";

const NewAgreementCard = () => {
  const { data: agreementCounts, isLoading } = useAgreementsCount();

  const totalAgreementCounts = agreementCounts && agreementCounts?.data;
  const history = useHistory();
  const modulePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_agreement_view;
  const userPermissions = useRecoilValue(permissionsSelector);

  return (
    <>
      <div
        className="flex w-full bg-tertiary lg:p-4 md:p-2 rounded-lg cursor-pointer"
        onClick={() => {
          if (userPermissions.includes(modulePermission)) {
            const urlPath = "/carrieragreementmgmt/agreements";
            history.push({
              pathname: urlPath,
            });
          }
        }}
      >
        <DashboardCard2
          text="Agreement"
          count={isLoading ? "..." : totalAgreementCounts}
          image={
            <NewspaperIcon className="text-white rounded-lg h-7 w-7 p-1" />
          }
          hasAccess={userPermissions.includes(modulePermission) ? true : false}
        />
        {userPermissions.includes(modulePermission) ? (
          ""
        ) : (
          <div className="relative">
            <Tooltip
              id="agreement"
              place="top"
              effect="solid"
              type="info"
              border={false}
              arrowColor="#3a3b3c"
              // borderColor="#0078d7"
              backgroundColor="#3a3b3c"
              textColor="white"
            />
            <InformationCircleIcon
              data-tip={
                "Contact your System Administrator to secure access to this module."
              }
              data-for="agreement"
              className="h-6 w-6 mr-2 text-white"
            />
          </div>
        )}
      </div>

      {/* ) : ( */}
      {/* <div className="flex w-full bg-tertiary lg:p-4 md:p-2 rounded-lg cursor-pointer" />
      )} */}
    </>
  );
};

export default NewAgreementCard;
